export default {
  quizData: {},
  quizState: {
    rfQuiz: {},
    mumQuiz: {},
    lmQuiz: []
  }
};
